// Selectors so surfaces read one place for the unread badge and panel state.
export const selectSupportOpen = (state) => state.support.open;
export const selectSupportView = (state) => state.support.view;
export const selectSupportActiveRef = (state) => state.support.activeRef;
export const selectSupportConfig = (state) => state.support.config;
export const selectSupportTransport = (state) => state.support.transport;
export const selectSupportServing = (state) => state.support.serving;
export const selectSupportUnreadTotal = (state) => state.support.unread.total;
export const selectSupportUnreadByRef = (state) => state.support.unread.by_ref;
export const selectSupportOutbox = (state) => state.support.outbox;
export const selectOutboxForRef = (state, ref) =>
  state.support.outbox.filter((m) => m.ref === ref);
